import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/activity";

const api = getApi(fetchURL);

export const RetrieveForYouPage = async (dataPage: number) => {
  const res = await api.post("/retrieveForYou", { dataPage: dataPage });
};

export const getEventsToLink = (maxDate: Date) => {
  let data = {
    typeEvents: "upcoming", 
    dataPage: 1,
    addEvent : true,
    maxDate: maxDate.toISOString().split("T")[0]
  }
  return api.post('searchDocuments', data).then((r) => r.data);
}